import React from 'react';
import { ModalBody } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader } from 'reactstrap';

const TermsAndConditions = ({ modal, setModal }) => {
  const toggle = () => setModal(!modal);
  return (
    <Modal isOpen={modal} toggle={toggle} className='pb-0' size='lg' scrollable centered>
      <ModalHeader className='border-0 pb-0 ' toggle={toggle} >
        <h5 className='fw-bold' >Algemene Voorwaarden</h5>
      </ModalHeader>
      <ModalBody className='px-4 pb-4' >
        <div className="terms-and-conditions">
          <ul className='m-0 p-0' style={{ listStyle: 'none' }} >
            <li>
              <h6 className='' style={{ fontWeight: 700 }}>Inleiding</h6>
              <p className='text-muted' >Welkom bij werkenindezwembranche.nl. Door onze website te gebruiken, stemt u in met deze Algemene Voorwaarden. Als u vragen heeft over deze voorwaarden, kunt u contact met ons opnemen via info@werkenindezwembranche.nl.
                Gebruik van de Jobboard</p>
              <ol className='text-muted'>
                <li>
                  <strong className='text-dark' >Doel:</strong>  Ons jobboard is uitsluitend bedoeld voor het plaatsen en zoeken van vacatures binnen de zwembranche. Informatie die wordt geplaatst door gebruikers moet relevant zijn voor deze doeleinden.
                </li>
                <li>
                  <strong className='text-dark' >Volledigheid en Nauwkeurigheid: </strong> Gebruikers mogen geen onvolledige, onjuiste of misleidende informatie plaatsen. Werkgevers dienen ervoor te zorgen dat alle geposte vacatures voldoen aan de geldende wet- en regelgeving.
                </li>
                <li>
                  <strong className='text-dark' >Discriminatieverbod: </strong>Wij behouden ons het recht voor om vacatures of gebruikers te verwijderen die discrimineren op basis van ras, kleur, religie, geslacht, nationale afkomst, handicap, of andere beschermde kenmerken.
                </li>
                <li>
                  <strong className='text-dark' >Inhoud en Gedrag: </strong>Gebruikers mogen geen lasterlijke, obsceen, bedreigende of anderszins aanstootgevende inhoud posten. Het gebruik van ons platform voor illegale activiteiten is strikt verboden.
                </li>
              </ol>
            </li>
            <li>
              <h6 className='mt-3' style={{ fontWeight: 700 }}>
                Privacy en Gegevensbescherming</h6>
              <ol className='text-muted'>
                <li>
                  <strong className='text-dark' >Verzameling en Gebruik van Gegevens:</strong> Persoonlijke gegevens die via ons platform worden verzameld, zullen worden gebruikt in overeenstemming met onze Privacyverklaring. Werkgevers zijn verantwoordelijk voor de verwerking van gegevens van sollicitanten en moeten een eigen privacybeleid handhaven.
                </li>
                <li>
                  <strong className='text-dark' >Gegevensbescherming: </strong> Wij nemen redelijke maatregelen om de veiligheid van uw gegevens te waarborgen, maar kunnen geen absolute bescherming garanderen.
                </li>
                <li>
                  <strong className='text-dark' >Rechten van Gebruikers: </strong> Gebruikers hebben het recht om hun persoonsgegevens in te zien, te corrigeren of te verwijderen. Verzoeken kunnen worden ingediend via info@werkenindezwembranche.nl.
                </li>
              </ol>
            </li>
            <li>
              <h6 className='mt-3' style={{ fontWeight: 700 }}>Cookies en Tracking</h6>
              <ol className='text-muted'>
                <li>
                  <strong className='text-dark' >Gebruik van Cookies: </strong> Wij maken gebruik van functionele, analytische en tracking cookies om de gebruikerservaring te verbeteren. Bij het eerste bezoek aan onze website vragen wij uw toestemming voor het plaatsen van cookies.
                </li>
                <li>
                  <strong className='text-dark' >Afmelden voor Cookies: </strong> U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kunt u alle eerder opgeslagen informatie via de instellingen van uw browser verwijderen.
                </li>
              </ol>
            </li>
            <li>
              <h6 className='mt-3' style={{ fontWeight: 700 }}>Beperkingen en Verantwoordelijkheden</h6>
              <ol className='text-muted'>
                <li>
                  <strong className='text-dark' >Aansprakelijkheid: </strong> werkenindezwembranche.nl is niet verantwoordelijk voor de juistheid van vacatures of de handelingen van werkgevers en sollicitanten. Wij aanvaarden geen aansprakelijkheid voor enig verlies of schade voortvloeiend uit het gebruik van ons platform.
                </li>
                <li>
                  <strong className='text-dark' >Vrijwaring: </strong> Gebruikers stemmen ermee in om werkenindezwembranche.nl schadeloos te stellen voor enige claims voortvloeiend uit hun gebruik van het platform.
                </li>
              </ol>
            </li>
            <li>
              <h6 className='mt-3' style={{ fontWeight: 700 }}> Wijzigingen en Beëindiging</h6>
              <ol className='text-muted'>
                <li>
                  <strong className='text-dark' >Wijzigingen: </strong> Wij behouden ons het recht voor om deze voorwaarden op elk moment te wijzigen. Wij zullen gebruikers op de hoogte stellen van substantiële wijzigingen via onze website.
                </li>
                <li>
                  <strong className='text-dark' >Beëindiging: </strong> Wij behouden ons het recht voor om de toegang tot ons platform te beëindigen voor gebruikers die deze voorwaarden overtreden.
                </li>
              </ol>
            </li>
            <p className="text-muted mt-2" >
              Contactgegevens <br />
              <strong className="text-dark" >
                <Link to={'https://werkenindezwembadbranche.nl'} >werkenindezwembranche.nl</Link></strong> <br />
              <strong className="text-dark" > E-mail: <Link to={'mailTo:info@werkenindezwembranche.nl'} >info@werkenindezwembranche.nl</Link> </strong>
            </p>
          </ul>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TermsAndConditions;
